






























































































































































































































































































import Vue from "vue";
import BaseModalWindow from "@/app/shared/components/base/BaseModalWindow.vue";
import BaseSearchInput from "@/app/shared/components/base/BaseSearchInput.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import { $eventsBus } from "@/main";
import utils from "@/app/shared/utils/utils.js";

export default Vue.extend({
  name: "EndCardEditWindow",
  components: { BaseModalWindow, BaseSearchInput, BaseButton, BaseInput },
  mixins: [utils],
  props: {
    packshot: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      filesToUpload: [],
      filesToUploadCount: 0,
      updatedPackshot: null,
      sizesInLoading: [],
      loading: false,
      isRenamingActive: false,
      isDragOver: false,
    };
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
  },
  created() {},
  mounted() {
    this.updatedPackshot = JSON.parse(JSON.stringify(this.packshot));
    $eventsBus.$emit("muteMainContent", true);
  },
  watch: {
    filesToUpload: function () {
      if (
        this.filesToUploadCount !== 0 &&
        this.filesToUpload.length === this.filesToUploadCount
      ) {
        this.filterAndStartUpload(this.packshot);
      }
    },
  },
  methods: {
    startRename() {
      this.isRenamingActive = true;
      this.oldName = this.updatedPackshot.name;
    },
    stopRename() {
      this.isRenamingActive = false;
      if (this.updatedPackshot.name === "") {
        this.updatedPackshot.name = this.oldName;
      }
      this.oldName = "";
    },
    closeWindow(event, saved = false) {
      if (this.loading) {
        return;
      }
      if (!saved) {
        this.setSettings(this.packshot);
      }

      $eventsBus.$emit("muteMainContent", false);
      this.$emit("close");
    },
    saveChanges() {
      if (this.sizesInLoading.length !== 0 || this.loading) {
        return;
      }
      if (
        !this.checkAllItemsVariationsPackshotsWithCurrent(this.updatedPackshot)
      ) {
        return;
      }
      this.setSettings(this.updatedPackshot, true);
    },
    checkAllItemsVariationsPackshotsWithCurrent(packshot) {
      let itemsCount = 0;
      let variationsCount = 0;
      let variationsWithEndCardToDelete = [];
      let message = "";
      this.items.forEach((item) => {
        let isHasEndCardsToDelete = false;
        item.variations.forEach((variation) => {
          if (
            variation.endCard.packshot &&
            variation.endCard.packshot.packId === packshot.packId &&
            !packshot.list[variation.currentSize.name.toLowerCase()]
          ) {
            isHasEndCardsToDelete = true;
            variationsCount++;
            variationsWithEndCardToDelete.push(variation);
          }
        });
        itemsCount += isHasEndCardsToDelete ? 1 : 0;
      });
      message =
        "In " +
        itemsCount +
        " video items in " +
        variationsCount +
        " variations, the End Card will be removed. Continue?";
      if (itemsCount > 0) {
        let isDelete = confirm(message);
        if (isDelete) {
          variationsWithEndCardToDelete.forEach((v) => {
            v.endCard.packshot = null;
            v.recalcFileOutputParameters();
          });
        }
        return isDelete;
      } else {
        return true;
      }
    },
    setSettings(packshotToSave, isExit = false) {
      this.loading = true;
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };
      let route = "/packshots/setSettings";
      this.axios
        .post(
          route,
          {
            id: packshotToSave.packId,
            name: packshotToSave.name,
            settings: {
              s: packshotToSave.list.s ? packshotToSave.list.s.id : -1,
              f: packshotToSave.list.f ? packshotToSave.list.f.id : -1,
              h: packshotToSave.list.h ? packshotToSave.list.h.id : -1,
              v: packshotToSave.list.v ? packshotToSave.list.v.id : -1,
              p: packshotToSave.list.p ? packshotToSave.list.p.id : -1,
            },
            sessionId: this.$store.state.userInfo.sessionId,
          },
          config
        )
        .then((res) => {
          this.loading = false;
          if (isExit) {
            this.closeWindow(null, true);
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    onDragOver(event: DragEvent): void {
      event.preventDefault();
      this.isDragOver = true;
    },
    onDragLeave(event: DragEvent): void {
      if (
        event.relatedTarget &&
        (<HTMLElement>event.relatedTarget).className.includes(
          "packshots-container"
        )
      ) {
        return;
      }

      this.isDragOver = false;
    },
    onDrop(event: DragEvent): void {
      event.preventDefault();
      const files = event.dataTransfer.files;
      this.validateAndUploadFiles(files);
      this.isDragOver = false;
    },
    onAddNewFile() {
      (<HTMLElement>this.$refs.fileInput).click();
    },
    onFileChanged(event: any) {
      let files: FileList = event.target.files;
      this.validateAndUploadFiles(files);
      event.target.value = "";
    },
    validateAndUploadFiles(files) {
      let result: File[] = [];
      const maxCount = 10;
      let maxIndex = files.length > maxCount ? maxCount : files.length;
      for (let i = 0; i < maxIndex; i++) {
        result.push(<File>files.item(i));
      }
      this.filesToUploadCount = result.length;
      result.forEach((f) => this.checkFileSize(f, this.saveResolutions));
      //Uploading will be after filtering. Check 'watch' of filesToUpload
      //this.uploadFiles(result);
    },
    checkFileSize(file, saveResolutionsCallback) {
      let isS = false;
      let reader = new FileReader();
      let fileType = file.type;
      reader.addEventListener(
        "load",
        function () {
          let dataUrl = reader.result;
          let videoEl = document.createElement("video");
          videoEl.style.display = "none";
          document.body.append(videoEl);
          videoEl.src = dataUrl.toString();

          let videoTagRef = videoEl;
          videoTagRef.addEventListener("loadedmetadata", function (e) {
            saveResolutionsCallback(
              file,
              videoTagRef.videoWidth,
              videoTagRef.videoHeight
            );
            document.body.removeChild(videoTagRef);
          });
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    saveResolutions(file, videoWidth, videoHeight) {
      this.filesToUpload.push({
        file: file,
        w: videoWidth,
        h: videoHeight,
        r: videoWidth / videoHeight,
        rStr: this.calcStrSize(videoWidth / videoHeight),
      });
    },
    filterAndStartUpload(packshot) {
      let filteredFilesToUpload = [];
      if (this.filesToUpload.some((f) => f.w === 1920 && f.h === 1920)) {
        //Slicer
        filteredFilesToUpload = this.filesToUpload.filter(
          (f) => f.w === 1920 && f.h === 1920
        );
        if (filteredFilesToUpload.length > 1) {
          alert(
            "You loaded more then one slicer videos. Last one will be split to five videos."
          );
          filteredFilesToUpload = [filteredFilesToUpload.pop()];
        } else if (this.filesToUpload.length > filteredFilesToUpload.length) {
          alert(
            "You loaded more than one video and one is slicer video. It will be split to five videos."
          );
          filteredFilesToUpload = [filteredFilesToUpload.pop()];
        }
        this.sizesInLoading = ["s", "f", "p", "v", "h"];
      } else {
        let repeatedSizes = [];
        this.filesToUpload.forEach((fileObject) => {
          let repeatedIndex = filteredFilesToUpload.findIndex(
            (f) => f.r === fileObject.r
          );
          if (repeatedIndex != -1) {
            repeatedSizes.push(fileObject.r);
            filteredFilesToUpload.splice(repeatedIndex, 1);
          }
          filteredFilesToUpload.push(fileObject);
        });
        if (repeatedSizes.length > 0) {
          alert(
            "Some of the loaded videos are the same size. Only the latest videos will be uploaded."
          );
        }
        this.sizesInLoading = filteredFilesToUpload.map((f) =>
          f.rStr.toLowerCase()
        );
      }
      this.uploadFiles(
        packshot,
        filteredFilesToUpload.map((fileObject) => fileObject.file)
      );
      this.filesToUpload = [];
      this.filesToUploadCount = 0;
    },
    uploadFiles(packshot, files: File[]) {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      let data = new FormData();
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        data.append("files[" + i + "]", file);
      }
      data.append("sessionId", this.$store.state.userInfo.sessionId);
      data.append("packId", packshot.packId)

      let route = "/packshots/filesUploadMulti";

      this.axios
        .post(route, data, config)
        .then((res) => {
          res.data.forEach((file) => {
            this.updatedPackshot.list[file.rStr.toLowerCase()] = file;
          });
          this.$forceUpdate();
          this.sizesInLoading = [];
        })
        .catch((err) => {
          console.log(err);
          this.sizesInLoading = [];
        });
    },
  },
});
